import {styled, Button, Stack} from '@mui/material'

export const ContractTypeButton = styled(Button)(() => ({
  width: '100%',
  height: '7rem',
}))

export const MessageWrapper = styled(Stack)(() => ({
  paddingLeft: '1rem',
}))
